module.exports = __webpack_public_path__ + "static/media/Home.b0ade933.svg";